import { API, HOST } from '@/utils/http'
import { createOrgBoundSession } from '@/services/orgSession'

// CloudFront signed-cookie session for direct browser → CloudFront → S3 tile
// reads (ADR-0016). apiv3 sets HttpOnly CloudFront-* cookies scoped to the
// active org's tile prefix; the browser then attaches them automatically to
// same-origin /s3/lyr/... tile fetches. JS only tracks { orgId, expiresAt } —
// enough to schedule refresh and to gate tile URLs during the org-switch gap
// (the cookies themselves are HttpOnly and never read here).

const s3 = createOrgBoundSession('S3 cookie session', async (orgId) => {
  // withCredentials so the Set-Cookie response is stored and cookies ride the
  // request. Same-origin today, but explicit for safety.
  const { data } = await API.post(`${HOST}/org/${orgId}/s3/cookies`, null, { withCredentials: true })
  return { expiresAt: data.expires_at }
})

// transformRequest / tileUrl read this synchronously on the hot path.
export function getS3SessionSnapshot() {
  return s3.session.value
}

export const refreshS3Session = s3.refresh
export const clearS3Session = s3.clear
export const bindS3SessionToOrg = s3.bindToOrg
